import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheckIcon, CalendarIcon, CameraIcon } from 'lucide-react';
export function SimpleSteps() {
  const steps = [{
    number: 1,
    icon: ClipboardCheckIcon,
    title: 'Answer a 2-minute questionnaire',
    description: "Quick assessment to confirm you're the right stage for treatment."
  }, {
    number: 2,
    icon: CalendarIcon,
    title: 'Follow the 3x/week protocol at home',
    description: '10 minutes per session, fits any schedule, completely hands-free'
  }, {
    number: 3,
    icon: CameraIcon,
    title: 'Upload check-in photos at set milestones',
    description: 'Track real progress with photo documentation at months 3 and 6'
  }];
  return <section className="w-full bg-white py-20 px-4" data-id="element-255">
      <div className="max-w-5xl mx-auto" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-257">
          {/* Headline */}
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-258">
            Three Simple Steps
          </h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-2xl mx-auto" data-id="element-259">
            No complexity. No guesswork. Just a clear protocol designed to show
            results.
          </p>

          {/* Steps Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-260">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="text-center" data-id="element-261">
                {/* Number Circle */}
                <div className="w-16 h-16 bg-brand-red rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-262">
                  <span className="text-2xl font-bold text-white" data-id="element-263">
                    {step.number}
                  </span>
                </div>

                {/* Icon */}
                <div className="w-12 h-12 mx-auto mb-4 text-brand-red" data-id="element-264">
                  <step.icon className="w-full h-full" aria-hidden="true" data-id="element-265" />
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-266">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 leading-relaxed" data-id="element-267">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}